import React from 'react'
import { useHistory } from 'react-router'

// utils
import { createEquipmentRequestCards } from './EquipmentRequstsForJob.collection.utils'

// graphql
import { useQuery } from '@apollo/client'
import { GET_ALL_EQUIPMENT_REQUESTS_FOR_JOB } from '../../../../../graphql/job/job.queries'

// components
import FourSectionCardListItem from '../../../../../components/collections/FourSectionCardListItem/FourSectionCardListItem.component'

export default function EquipmentRequestsForJob({ jobId }) {
    const history = useHistory()

    let cards = []

    const { data } = useQuery(GET_ALL_EQUIPMENT_REQUESTS_FOR_JOB, {
        variables: { id: jobId }
    })

    if(data && data.jobLite) {
        cards = [...createEquipmentRequestCards(data.jobLite)]
    }

    return (<div className='equipment-requests-for-job'>

        {
            cards.map(card => {
                return (<FourSectionCardListItem 
                    mainTitle={card.date}
                    subTitle={card.status}
                    leftData={[`${card.numItems} Item${card.numItems !== 1 ? 's' : ''}`]}
                    rightData={null}
                    onClick={() => history.push(`/requests/details/${card.id}`)} 
                />)
            })
        }
        
    </div>)
}